export default "__VITE_ASSET__DBea_O2b__"